import { UserProfileResponse } from '@shared/services/userProfile/service.types.ts';
import { DataStatuses } from '@shared/types/common.ts';
import { ONBOARDING_STATE } from '@shared/types/userProfile.types.ts';

export const userProfileFixture: UserProfileResponse = {
  id: '51628f54-35ff-4521-bbbc-6eeac2869237',
  role: 'EXTERNAL_DIRECT_CLIENT',
  email: 'example@example.com',
  invoicingEmail: 'example@example.com',
  companyName: 'Test Company',
  vatNumber: '1234567890',
  status: DataStatuses.PENDING,
  onboardingState: ONBOARDING_STATE.BILLING_INFO_NOT_FILLED,
};

export const userProfileUpdatePayloadFixture: Pick<UserProfileResponse, 'invoicingEmail' | 'vatNumber'> = {
  invoicingEmail: 'valid@email.com',
  vatNumber: '12345678901',
};
